<template>
    <div class="main-content">
        <list
            :columns="columns"
            :rows="users"
            :selectOptions="selectOptions"
            @inactivate="inactivateUser"
            @activate="activateUser"
            @edit="editUser"
        >
            <b-button
                @click="addUser"
                variant="primary"
                class="btn-rounded"
                slot="table-actions"
            >
                Adicionar
            </b-button>
        </list>
    </div>
</template>

<script>
export default {
    components: {
        List: () => import('@/components/List/List'),
    },
    data () {
        return {
            columns: [
                {
                    label: 'Nome',
                    field: 'displayName',
                    html: true,
                },
                {
                    label: 'E-mail',
                    field: 'email',
                },
                {
                    label: 'Ações',
                    field: 'button',
                    html: true,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
            ],
            selectOptions: {
                enabled: false,
            },
        }
    },
    methods: {
        addUser () {
            this.$store.dispatch('modals/open', 'addEditUser')
        },
        editUser (user) {
            this.$store
                .dispatch('modals/setData', {
                    key: 'addEditUserData',
                    data: user,
                })
                .then(() => this.$store.dispatch('modals/open', 'addEditUser'))
        },
        inactivateUser (user) {
            this.$bvModal
                .msgBoxConfirm(
                    `Você realmente deseja inativar o usuário ${user.displayName}?`,
                    {
                        title: 'Você tem certeza?',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'dark',
                        okTitle: 'Sim',
                        cancelTitle: 'Não',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then(confirm => {
                    if (!confirm) return
                    this.$store.dispatch('auth/inactivateUser', user.uid)
                })
                .catch((err) => {
                    console.log('%c%s:%i', 'color: darkgreen', 'UserList.vue', 86, err)
                })
        },
        activateUser (user) {
            this.$bvModal
                .msgBoxConfirm(
                    `Você realmente deseja ativar o usuário ${user.displayName}?`,
                    {
                        title: 'Você tem certeza?',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'dark',
                        okTitle: 'Sim',
                        cancelTitle: 'Não',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then(confirm => {
                    if (!confirm) return
                    this.$store.dispatch('auth/activateUser', user.uid)
                })
                .catch((err) => {
                    console.log('%c%s:%i', 'color: darkgreen', 'UserList.vue', 110, err)
                })
        },
        loadUsers () {
            this.$store.dispatch('auth/loadUsers')
        },
    },
    computed: {
        users () {
            return this.$store.getters['auth/users']
        },
    },
    created () {
        this.loadUsers()
    },
}
</script>

<style lang="scss">
.user-list-avatar {
    display: inline-block;
    width: 40px;
    height: 40px;
}
</style>
